import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { Dialog, IconButton, DialogTitle, DialogContent, Button } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

import './style.css'
import { DialogNewFormaPago } from './DialogNewFormaPago'
import { Model } from '../../../models/model'

import { generalGetFormasPagosVentas, generalGetFormasPagos } from '../../../redux/actions/general'
import NumberFormat from 'react-number-format'

export const DialogFormaPago = ({ open, setOpen, origen }) => {

    const dispatch = useDispatch()
    const { listaFormasPagos, listaFormasPagosVentas } = useSelector(state => state.general)
    const [openNewFormaPago, setOpenNewFormaPago] = useState(false)
    const [formasPagoList, setFormasPagoList] = useState(origen === 'ventas' ? listaFormasPagosVentas : listaFormasPagos)

    const [initialData, setInitialData] = useState({
        id: 0,
        nombre: '',
        estado: true,
        dias: 0,
        porcentaje: 0
    })

    useEffect(() => {
        setFormasPagoList(origen === 'ventas' ? listaFormasPagosVentas : listaFormasPagos)
    }, [listaFormasPagos, listaFormasPagosVentas, origen])

    const handleAddNew = () => {

        setInitialData({
            id: 0,
            nombre: '',
            estado: true,
            dias: 0,
            porcentaje: 0
        })

        setOpenNewFormaPago(true)

    }

    const openEdit = (item) => {

        setInitialData({
            id: item.id,
            nombre: item.nombre,
            estado: item.status,
            dias: item.dias,
            porcentaje: item?.porcentaje || 0
        })

        setOpenNewFormaPago(true)

    }

    const handleDelete = async (item) => {

        const resultDelete = await Model.delete({
            url: `formas_pagos/from-params/${item.id}/${origen}`,
            resultData: true
        })

        console.log({ resultDelete })

        if (origen === 'ventas') {
            dispatch(generalGetFormasPagosVentas(resultDelete))
        } else {
            dispatch(generalGetFormasPagos(resultDelete))
        }

    }

    return (
        <Dialog
            className='dialogoContacs'
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="simple-dialog-title"
        >
            <DialogTitle id="scroll-dialog-title">
                Formas de pago para {origen}
                <IconButton
                    aria-label="close"
                    style={{ padding: '0', float: 'right' }}
                    onClick={() => setOpen(false)}
                >
                    <CloseIcon style={{ color: '#78667E' }} />
                </IconButton>
            </DialogTitle>

            <DialogContent>
                <div className="table-responsive">

                    <div className='m-2'>
                        {formasPagoList.length === 0 && <h3 style={{ fontSize: '14px' }}>Aún no existe formas de pagos agregadas</h3>}
                        <Button
                            className='p-btn-primary'
                            variant="contained"
                            size="small"
                            type='button'
                            onClick={handleAddNew}
                        >
                            + Agregar
                        </Button>
                    </div>

                    {formasPagoList.length > 0 &&
                        <table className="table p-table-global">
                            <thead className='p-thead-global'>
                                <tr className="text-center p-tr-titles-global">
                                    <th className='text-start'>Forma de pago</th>
                                    <th className='text-center'>Días</th>
                                    <th className='text-center'>% Facturación</th>
                                    <th className='text-center'>Habilitado</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {formasPagoList?.map(item => (
                                    <tr key={item.id} className='p-tr-body-global'>
                                        <td className="text-start" style={{ textTransform: 'uppercase' }}>
                                            {item.nombre || '---'}
                                        </td>
                                        <td className="text-center" style={{ textTransform: 'uppercase' }}>
                                            {item.dias || 0}
                                        </td>
                                        <td className="text-center" style={{ textTransform: 'uppercase' }}>
                                            <NumberFormat
                                                displayType='text'
                                                size="small"
                                                value={item?.porcentaje || 0}
                                                suffix='%'
                                                decimalScale={2}
                                                fixedDecimalScale
                                            />
                                        </td>
                                        <td className="text-center" style={{ textTransform: 'none' }}>
                                            {item.status ?
                                                <i
                                                    className="bi bi-check-circle"
                                                    style={{ color: '#8E24AA', fontSize: '14px' }}
                                                ></i>
                                                :
                                                <i
                                                    className="bi bi-x-circle"
                                                    style={{ fontSize: '14px' }}
                                                ></i>
                                            }
                                        </td>
                                        <td className="text-center">
                                            <i className="bi bi-pencil" style={{ cursor: 'pointer' }} onClick={() => openEdit(item)}></i>
                                            <i className="bi bi-trash ms-3" style={{ cursor: 'pointer' }} onClick={() => handleDelete(item)}></i>
                                        </td>
                                    </tr>
                                ))
                                }
                            </tbody>
                        </table>
                    }

                </div>
            </DialogContent>

            {openNewFormaPago &&
                <DialogNewFormaPago
                    open={openNewFormaPago}
                    setOpen={setOpenNewFormaPago}
                    initialData={initialData}
                    origen={origen}
                />
            }

        </Dialog>
    )
}